type UiConfig = Parameters<typeof defineAppConfig>[0]['ui']

export const uiConfig: UiConfig = {
  colors: {
    primary: 'sky',
    neutral: 'neutral',
    tertiary: 'tertiary',
  },
  badge: {
    slots: {
      base: 'rounded-full!',
    },
  },
  button: {
    slots: {
      base: 'rounded-none',
    },
    variants: {
      size: {
        xl: {
          base: 'px-6',
        },
      },
    },
    defaultVariants: {
      size: 'xl',
    },
  },
  formField: {
    slots: {
      label: 'text-xs font-normal text-muted',
      error: 'mt-1 text-xs',
      help: 'mt-1 text-xs text-dimmed',
    },
  },
  input: {
    slots: {
      base: 'rounded-none',
    },

    defaultVariants: {
      size: 'xl',
    },
  },

  inputTags: {
    defaultVariants: {
      size: 'xl',
    },
  },

  textarea: {
    slots: {
      base: 'rounded-none',
    },
    defaultVariants: {
      size: 'xl',
    },
  },
  inputNumber: {
    slots: {
      base: 'rounded-none',
    },
    defaultVariants: {
      size: 'xl',
    },
  },
  inputDate: {
    slots: {
      base: 'rounded-none',
    },
    defaultVariants: {
      size: 'xl',
    },
  },
  select: {
    slots: {
      base: 'rounded-none',
    },
    defaultVariants: {
      size: 'xl',
    },
  },
  selectMenu: {
    slots: {
      base: 'rounded-none',
    },
    defaultVariants: {
      size: 'xl',
    },
  },
  inputMenu: {
    slots: {
      base: 'rounded-none',
    },
  },
  table: {
    slots: {
      th: 'px-2 py-1 text-xs font-normal text-muted',
      td: 'px-2 py-4 text-highlighted',
    },
  },
  modal: {
    slots: {
      content: 'divide-none rounded-none!',
    },
  },
  alert: {
    slots: { root: 'rounded-none' },
  },
  pinInput: {
    slots: {
      base: 'rounded-none',
    },
  },
  slideover: {
    slots: {
      overlay: 'bg-black/40',
    },
  },
  dropdownMenu: {
    slots: {
      content: 'rounded-none',
    },
  },
  card: {
    slots: {
      root: 'rounded-none',
    },
  },
}
